import { PaginatedCcdExportDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const ccdExportRequests = {
  getCcdExportList: EndpointDefinition.get<
    PaginatedCcdExportDto,
    {
      searchTerm?: string;
      startDate?: number;
      endDate?: number;
      'page-start': number;
      'page-size': number;
      'sort-direction'?: 'ASC' | 'DESC';
    }
  >({
    name: 'getCcdExportList',
    route: '/hospitalizations/ccd-export',
  }),
};
